import { PassengerMockup, HostMockup } from "./PhoneMockups";
import { ArrowRight } from "lucide-react";

export default function RoleSwitch() {
  return (
    <section
      id="role-switch"
      data-testid="role-switch-section"
      className="relative py-28 md:py-36 overflow-hidden bg-[#F9FAFB] border-t border-[#e5e7eb]"
    >
      <div
        className="absolute inset-0 -z-10"
        style={{
          background:
            "radial-gradient(ellipse at 30% 40%, rgba(95,168,54,0.10), transparent 55%), radial-gradient(ellipse at 70% 60%, rgba(36,48,63,0.06), transparent 55%)",
        }}
        aria-hidden
      />

      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          {/* Left content */}
          <div className="lg:col-span-5 reveal">
            <span className="font-display text-[11px] uppercase tracking-[0.25em] text-[#5FA836] font-bold">
              The 10-minute switch · Our USP
            </span>
            <h2 className="mt-4 font-display text-4xl md:text-5xl xl:text-6xl font-black tracking-[-0.03em] leading-[1.05] text-[#24303F]">
              One app.
              <br />
              <span className="text-[#24303F]">Co-traveller</span>{" "}
              <span className="text-gray-400">↔</span>
              <br />
              <span className="text-[#5FA836]">Trip Host</span>
              <br />
              in 10 mins.
            </h2>
            <p className="mt-7 font-body text-gray-600 text-base md:text-lg leading-relaxed max-w-xl">
              Most ride apps lock you into one role. RideMate doesn't.
              Booked a seat this morning? Got your car back this evening?
              Toggle to <span className="text-[#5FA836] font-semibold">Trip Host</span>,
              post your route and start earning — all in under ten minutes.
            </p>

            {/* Animated role toggle */}
            <div
              data-testid="role-toggle-demo"
              className="mt-8 relative inline-flex h-14 w-72 rounded-full border border-[#e5e7eb] bg-white p-1"
            >
              <div
                className="role-pill absolute top-1 bottom-1 w-[calc(50%-4px)] rounded-full"
                style={{ left: 4 }}
              />
              <div className="relative z-10 grid grid-cols-2 w-full">
                <div className="role-label-left grid place-items-center font-display font-bold text-[13px]">
                  Co-traveller
                </div>
                <div className="role-label-right grid place-items-center font-display font-bold text-[13px]">
                  Trip Host
                </div>
              </div>
            </div>

            <a
              href="#waitlist"
              data-testid="role-switch-cta"
              className="mt-10 inline-flex items-center gap-2 font-display font-bold text-[#5FA836] hover:gap-3 transition-all"
            >
              Reserve your role <ArrowRight className="w-4 h-4" />
            </a>
          </div>

          {/* Right: dual phones */}
          <div className="lg:col-span-7 reveal">
            <div className="relative">
              <div className="grid grid-cols-2 gap-4 md:gap-8">
                <div className="ring-blue rounded-[2.6rem]">
                  <PassengerMockup />
                </div>
                <div className="ring-green rounded-[2.6rem] mt-12 md:mt-20">
                  <HostMockup />
                </div>
              </div>
              <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-20 hidden md:block">
                <div className="font-display text-[10px] uppercase tracking-[0.25em] text-[#24303F] font-bold border border-[#e5e7eb] rounded-full px-3 py-1.5 bg-white shadow-md">
                  ↔ &nbsp; 10 min
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
